import React from 'react';
import { TableCell } from '@mui/material';
import { formatCurrency } from '../../utils/formatNumber';

class GridCommissionsCell extends React.Component {
    render() {
        const { value, field, row, styles, context } = this.props;
        const allCommissions = context.getState().controllersData.publicCommissions || [];
        const shownAs = field && field.showAs ? field.showAs : 'name';
        let commissions = value ? JSON.parse(value) : [];
        // let commissions = [{ "id": 110, "cost": 1, "value": 500 }];
        if (Object.keys(commissions).length === 0) {
            commissions = [];
        }
        const baseStyle = styles;

        const extra =
            typeof field.extraRender === 'function'
                ? field.extraRender(row)
                : null;

        // commissionAgentJson -example- [{"id": 110, "cost": 1, "value": 500}]
        // + commissionMerchantJson -example- [{"id": 72, "cost": 1, "value": 1000}, {"id": 71, "cost": 1, "value": 45000}, {"id": 63, "cost": 1, "value": 500}, {"id": 87, "cost": 1, "value": 500}]
        // + commissionGwJson -example-  [{"id": 88, "cost": 1, "value": 20}]
        // + totalAgentCommission
        // + totalIncludedCommissionGwCost
        // + totalOntopCommissionGwCost
        return (
            <TableCell key={this.props.field.id} align="left" sx={{ ...baseStyle }}>
                {commissions.length > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {commissions.map((commission, index) => {
                            const found = allCommissions.find(c => c.id === commission.id);
                            const label = found ? found[shownAs] : null;
                            return (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        flexDirection: 'column',
                                        flexGrow: 1,
                                        gap: '2px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <span>
                                        {label}
                                    </span>
                                    <span>
                                        {formatCurrency(commission.value)}
                                    </span>
                                    {extra && (
                                        <span>
                                    total: {formatCurrency(extra)}
                                        </span>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    formatCurrency(0)
                )}
            </TableCell>
        );
    }
}

export default GridCommissionsCell;
